<script>
import Vue from 'vue';

export default {
  name: 'base-form',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {}
    };
  },
  watch: {
    form: {
      handler: function(v) {
        this.$emit('input', v);
      }
    }
  },
  /**
   * @param label
   */
  render(h) {
    const _this = this;
    //过滤hidden为true的控件
    const columns = this.columns.filter(item => !item.hidden);
    columns.map(i => {
      // 初始化 表单字段名 和 字段值
      if (i.type === 'daterange' || i.type === 'datetimerange') {
        const [n1, n2] = i.fieldKeys;
        if (!(n1 in this.form) && !(n2 in this.form)) {
          this.$set(this.form, n1, '');
          this.$set(this.form, n2, '');
        }
      } else {
        if (!(i.fieldKey in this.form)) {
          this.$set(this.form, i.fieldKey, '');
        }
      }
    });

    // 渲染 视图
    return h(
      'el-form',
      {
        props: {
          inline: 'inline',
          labelSuffix: ' : ',
          model: _this.form,
          rules: _this.rules
        },
        ref: 'form'
      },
      [
        columns.map(i => {
          const { fieldKey, label, placeholder } = i;

          // 渲染 表单
          return h('el-form-item', {
            props: {
              label: label,
              prop: fieldKey
            },
            scopedSlots: {
              default: () => {
                if (i.type === 'daterange') {
                  const [n1, n2] = i.fieldKeys;
                  return h('el-date-picker', {
                    props: {
                      type: 'daterange',
                      valueFormat: 'yyyy-MM-dd',
                      value: [_this.form[n1], _this.form[n2]],
                      clearable: i.clearable,
                      ...i
                    },
                    on: {
                      input: function(v) {
                        if (v == null) {
                          _this.form[n1] = '';
                          _this.form[n2] = '';
                          return;
                        }
                        const [v1, v2] = v;
                        _this.form[n1] = v1;
                        _this.form[n2] = v2;
                      }
                    }
                  });
                }
                if (i.type === 'month') {
                  return h('el-date-picker', {
                    props: {
                      type: 'month',
                      valueFormat: 'yyyy-MM',
                      value: _this.form[i.fieldKey],
                      clearable: i.clearable
                    },
                    on: {
                      input: v => {
                        if (v == null) {
                          _this.form[i.fieldKey] = '';
                          return;
                        }
                        _this.form[i.fieldKey] = v;
                      }
                    }
                  });
                }
                if (i.type === 'datetimerange') {
                  const [n1, n2] = i.fieldKeys;
                  return h('el-date-picker', {
                    props: {
                      type: 'datetimerange',
                      valueFormat: 'yyyy-MM-dd HH:mm:ss',
                      value: [_this.form[n1], _this.form[n2]],
                      clearable: i.clearable,
                      ...i
                    },
                    on: {
                      input: function(v) {
                        if (v == null) {
                          _this.form[n1] = '';
                          _this.form[n2] = '';
                          return;
                        }
                        const [v1, v2] = v;
                        _this.form[n1] = v1;
                        _this.form[n2] = v2;
                      }
                    }
                  });
                }
                if (i.type === 'select') {
                  Vue.util.defineReactive(i, 'options', []);
                  let optionsData = i.options || [];
                  return h(
                    'el-select',
                    {
                      props: {
                        value: _this.form[fieldKey],
                        placeholder: placeholder,
                        filterable: i.filterable,
                        remote: i.remote,
                        clearable: i.clearable === void 0,
                        multiple: i.multiple,
                        collapseTags: i.collapseTags,
                        remoteMethod:
                          typeof i.remoteMethod === 'function'
                            ? i.remoteMethod.bind(i)
                            : function() {}
                      },
                      on: {
                        input: v => {
                          if (v === _this.form[fieldKey]) return;
                          _this.form[fieldKey] = v;
                        }
                      }
                    },
                    optionsData.map(o => {
                      return h('el-option', {
                        props: {
                          label: o.label,
                          value: o.value
                        }
                      });
                    })
                  );
                }
                if (i.type === 'autocomplete') {
                  return h('el-autocomplete', {
                    props: {
                      value: _this.form[fieldKey],
                      placeholder: placeholder,
                      maxlength: i.maxLength,
                      'fetch-suggestions': (queryString, cb) => {
                        i.querySearch ? i.querySearch(queryString, cb) : cb([]);
                      }
                    },
                    on: {
                      select: item => {
                        _this.form[fieldKey] = item.value;
                      },
                      input: v => {
                        if (v === _this.form[fieldKey]) return;
                        _this.form[fieldKey] = v;
                      }
                    }
                  });
                }
                return h('el-input', {
                  props: {
                    value: _this.form[fieldKey],
                    clearable: i.clearable === void 0
                  },
                  attrs: {
                    placeholder: placeholder || i.fieldKey
                  },
                  on: {
                    input: function(v) {
                      if (v === _this.form[fieldKey]) return;
                      _this.form[fieldKey] = v;
                    }
                  }
                });
              }
            }
          });
        }),
        !!_this.columns.length &&
          h('el-form-item', [
            h(
              'el-button',
              {
                props: {
                  type: 'primary'
                },
                style: {
                  marginRight: '8px'
                },
                on: {
                  click: function() {
                    if (_this.rules != null) {
                      _this.validate().then(() => {
                        _this.$emit('search', _this.form);
                      });
                    } else {
                      _this.$emit('search', _this.form);
                    }
                    // _this.searchHandler();
                  }
                }
              },
              '搜索'
            )
          ]),
        _this.$slots.default,
        _this.$slots.tableActions
      ]
    );
  },
  methods: {
    setClearable(item) {
      if (item.clearable === void 0) {
        return true;
      }
      return item.clearable;
    },
    resetForm() {
      this.$refs['form'].resetFields();
    },
    validate() {
      return this.$refs.form.validate();
    }
  }
};
</script>
<style>
.base-form {
  /*text-align: left;*/
  overflow: hidden;
  background: #fff;
  padding: 20px 10px 0 10px;
  /*border-radius: 4px;*/
  /*box-shadow: 0 1px 3px rgba(0, 0, 0, .3)*/
}

.autocomplete {
  width: auto !important;
  /*background: #46a6ff;*/
}
</style>
